import ajax from './ajax'

const ROOT_URL = process.env.VUE_APP_BASE_URL;
const FILE_BASE_URL = process.env.VUE_APP_FILE_BASE_URL;

const BASE_URL = ROOT_URL + '/shr-fund-api';

// 关于我们接口
 const home = (params) => ajax(BASE_URL + '/externalFundController/getFundAgencyList', params, 'GET');
 //机构项目管理
 const getFundAgencyManagementlist = (params) => ajax(BASE_URL + '/externalFundController/getFundAgencyManagementlist', params, 'GET');
 //新闻中心列表
 const getFundNewlist = (params) => ajax(BASE_URL + '/externalFundController/getFundNewlist', params, 'GET');
 //新闻中心列表
 const queryPlacardPageList = (params) => ajax(BASE_URL + '/externalFundController/queryPlacardPageList', params, 'GET');
 //信息公示列表
 const queryVolunteerPageList = (params) => ajax(BASE_URL + '/externalFundController/queryVolunteerPageList', params, 'GET');

// 关于我们 点击次数 统计
const queryFundAgencyById = (params) => ajax(BASE_URL + '/externalFundController/queryFundAgencyById', params, 'GET');

// 机构项目管理 点击次数 统计
const queryFundAgencyManagementById = (params) => ajax(BASE_URL + '/externalFundController/queryFundAgencyManagementById', params, 'GET');

// 新闻中心 点击次数 统计
const queryFundNewById = (params) => ajax(BASE_URL + '/externalFundController/queryFundNewById', params, 'GET');

// 信息公示 点击次数 统计
const queryPlacardById = (params) => ajax(BASE_URL + '/externalFundController/queryPlacardById', params, 'GET');

// 志愿者管理 点击次数 统计
const queryVolunteerById = (params) => ajax(BASE_URL + '/externalFundController/queryVolunteerById', params, 'GET');


export default {
    FILE_BASE_URL,
    home,
    getFundAgencyManagementlist,
    getFundNewlist,
    queryVolunteerPageList,
    queryPlacardPageList,
    queryFundAgencyById,
    queryFundAgencyManagementById,
    queryFundNewById,
    queryPlacardById,
    queryVolunteerById
}

